import React from "react";
import { graphql, Link } from "gatsby";
import ReactMarkdown from "react-markdown";
import Layout from "../components/App/Layout";
import SEO from "../components/App/SEO";
import Sidebar from "../components/Industry/Sidebar";
import PageBanner from "../components/Common/PageBanner";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";
import { removeMarkdownFormatting } from "../libs/utils";

const PageLink = ({ to, children, ...rest }) => {
  const handleClick = e => {
    e.preventDefault();
    window.___navigate(to);
  };
  return (
    <PaginationLink to={to} {...rest} onClick={handleClick}>
      {children}
    </PaginationLink>
  );
};

const IndustryDetail = ({ data }) => {
  const { title, content, slug, keywords } = data.industry;

  const prevId = data.prevIndustry.nodes.length > 0 ? data.prevIndustry.nodes[0].strapiId : null;
  const nextId = data.nextIndustry.nodes.length > 0 ? data.nextIndustry.nodes[0].strapiId : null;

  const plainText = removeMarkdownFormatting(content);
  const desc = plainText.substring(0, 140);

  return (
    <Layout stickyHeader>
      <SEO title={`${title}-大任软件新闻`} description={desc} keywords={keywords} />

      <PageBanner
        pageTitle={title}
        breadcrumbs={[
          { text: "首页", url: "/" },
          { text: "行业资讯新闻", url: "/industryInfo/all/page_1" },
        ]}
        activePageText="详情"
      />

      <section className="blog-details-area ptb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="section-title">
                <ReactMarkdown
                  allowDangerousHtml
                  renderers={{
                    link: ({ href, children }) => {
                      let newHref = href.replace(/https?:\/\/www\.darensoft\.com|www\.darensoft\.com/, "");
                      if (!newHref.startsWith("/")) {
                        newHref = "/" + newHref;
                      }
                      return (
                        <Link to={newHref} className="test">
                          {children}
                        </Link>
                      );
                    },
                  }}
                  className="text-left prades-indent"
                >
                  {content}
                </ReactMarkdown>
              </div>
              <Pagination listClassName="justify-content-around mb-0">
                <PaginationItem disabled={prevId === null}>
                  <PageLink to={`/industry/${prevId}`} previous>
                    上一篇
                  </PageLink>
                </PaginationItem>
                <PaginationItem disabled={nextId === null}>
                  <PageLink to={`/industry/${nextId}`} next>
                    下一篇
                  </PageLink>
                </PaginationItem>
              </Pagination>
            </div>
            <div className="col-lg-4 col-md-12">
              <Sidebar />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query GetSingleIndustry($strapiId: Int) {
    industry: strapiIndustry(strapiId: { eq: $strapiId }) {
      slug
      content
      title
      keywords
      image {
        childImageSharp {
          fixed {
            src
          }
        }
      }
    }
    nextIndustry: allStrapiIndustry(filter: { strapiId: { gt: $strapiId } }, sort: {order: DESC, fields: date}, limit: 1) {
      nodes {
        strapiId
      }
    }
    prevIndustry: allStrapiIndustry(filter: { strapiId: { lt: $strapiId } }, sort: {order: DESC, fields: date}, limit: 1) {
      nodes {
        strapiId
      }
    }
  }
`;

export default IndustryDetail;
